import { render } from "./PresavedSearches.vue?vue&type=template&id=4c27f832&scoped=true&ts=true"
import script from "./PresavedSearches.vue?vue&type=script&lang=ts"
export * from "./PresavedSearches.vue?vue&type=script&lang=ts"

import "./PresavedSearches.vue?vue&type=style&index=0&id=4c27f832&lang=scss&scoped=true"

import exportComponent from "/var/www/kun/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c27f832"]])

export default __exports__